module.exports = __webpack_public_path__ + "contatore-m-kUS.png";